<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box !important;
  user-select: text;
  text-decoration: none !important;
  -webkit-tap-highlight-color: transparent;
  /* 消除手機端高光藍底 */
  font-family: "微軟正黑體";
}
*:focus {
  outline: transparent;
}
body,
html {
  background-color: #1e1e1e;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cecece;
}

.el-tabs__item {
  font-weight: 700 !important;
  color: #ffe476;
}

.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #f7b25e;
}
.el-tabs__active-bar {
  background-color: #f7b25e;
}
.el-tabs__nav-wrap::after {
  height: 3px;
  background-color: #4c4c4c;
}

.el-select .el-input {
  min-width: 120px;
}

.el-select-dropdown__list {
  padding: 20px 0;
}

.el-input__inner,
.el-textarea__inner {
  background-color: rgb(59, 59, 59);
  color: #ccc;
}

.el-input-group__prepend {
  background-color: #07416e;
  color: #00ebfe;
  font-weight: 700;
}
.holderType {
  background-color: #e632c875;
  color: #fff;
}

.holderType .el-input__inner::placeholder {
  font-weight: 700;
  letter-spacing: 2px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue